import { useAuthStore } from '@/features/auth/auth-store';
import { useAuth } from '@/features/auth/use-auth';
import { useEffect } from 'react';

const DEBUG = false;

export function useTokenExpirationCheck() {
  const { refreshTokens } = useAuth();
  const { accessTokenExpiresAt, refreshToken } = useAuthStore();

  useEffect(() => {
    const checkTokenExpiration = async () => {
      if (!accessTokenExpiresAt || !refreshToken) return;

      const timeUntilExpiry = accessTokenExpiresAt - Date.now();
      if (DEBUG) {
        console.log(
          'access token expires in',
          timeUntilExpiry / 1000,
        );
      }

      const oneMinute = 60 * 1000;

      if (timeUntilExpiry < oneMinute) {
        await refreshTokens();
      }
    };

    const interval = setInterval(
      () => void checkTokenExpiration(),
      10000,
    );

    void checkTokenExpiration();

    return () => clearInterval(interval);
  }, [accessTokenExpiresAt, refreshToken, refreshTokens]);
}
